import { useMutation } from '@tanstack/react-query';

import { request } from '../request';
import { billitAuthorizationUrlSchema } from './schemas';

export const useBillitAuthorizationUrl = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await request('/oauth2/authorization/billit');

      const { redirectUrl } = billitAuthorizationUrlSchema.parse(response);

      return redirectUrl;
    },
  });
};
